import type { Order } from "@graphql/generated/types";
import type { PaymentValues } from "@lib/utils/checkoutHelper";
import type { IPaymentStrategy } from "@interfaces/payment-method/PaymentStrategy";
import type { IAdyenPaymentMethodStrategy } from "@interfaces/payment-method/AdyenPaymentMethodStrategy";
import { AdyenResolver } from "./adyenResolver";
import { AdyenDeferredPaymentStrategy } from "./payment-method-strategies/adyenDeferredPaymentStrategy";
import { AdyenAdvancedFlowStrategy } from "./payment-method-strategies/adyenAdvancedFlowStrategy";

export class AdyenStrategy implements IPaymentStrategy {
    private resolver: AdyenResolver;

    constructor() {
        this.resolver = new AdyenResolver(
            new Map<string, IAdyenPaymentMethodStrategy>([
                ["advancedFlow", new AdyenAdvancedFlowStrategy()],
                ["deferredPayment", new AdyenDeferredPaymentStrategy()],
            ])
        );
    }

    resolve(order: Order): PaymentValues {
        return this.resolver.resolve(order);
    }
}
